/* istanbul ignore file */

export enum DateSelectTriggerOperatorText {
    HasChanged = 'field has changed',
    DateFieldIsInTheLastXDays = 'field is in the past (days)',
    DateFieldIsInTheNextXDays = 'field is in the next (days)',
    DateFieldIsInPast = 'field is in the past',
    DateFieldIsInFuture = 'field is in the future',
    HasValue = 'field has a value',
    NoValue = 'field has no value',
    LessThan = 'field is earlier than',
    GreaterThan = 'field is later than',
    EqualTo = 'field is equal to',
    GreaterThanOrEqualTo = 'field is on or after',
    LessThanOrEqualTo = 'field is on or before',
}

export enum DateSelectTriggerOperatorGridText {
    HasChanged = 'has changed',
    DateFieldIsInTheLastXDays = 'is in the past ',
    DateFieldIsInTheNextXDays = 'is in the next ',
    DateFieldIsInPast = 'is in the past',
    DateFieldIsInFuture = 'is in the future',
    HasValue = 'has a value',
    NoValue = 'has no value',
    LessThan = 'is earlier than',
    GreaterThan = 'is later than',
    EqualTo = 'field is equal to',
    GreaterThanOrEqualTo = 'field is on or after',
    LessThanOrEqualTo = 'field is on or before',
}

export enum CheckBoxTriggerOperatorText {
    HasValue = 'field is checked',
    NoValue = 'field is not checked',
    HasChanged = 'field has changed',
}

export enum CheckBoxTriggerOperatorGridText {
    HasValue = 'is checked',
    NoValue = 'is not checked',
    HasChanged = 'has changed',
}

export enum DropdownTriggerOperatorText {
    HasChanged = 'field has changed',
    Equal = 'field is set to',
    NotEqual = 'field is not set to',
    HasValue = 'field has a value',
    NoValue = 'field has no value',
}

export enum DropdownTriggerOperatorGridText {
    HasChanged = 'has changed',
    Equal = 'is set to',
    NotEqual = 'is not set to',
    HasValue = 'has a value',
    NoValue = 'has no value',
}

export enum PersonTriggerOperatorText {
    HasChanged = 'field has changed',
    HasValue = 'field has a value',
    NoValue = 'field has no value',
    Equal = 'field is set to',
}

export enum PersonTriggerOperatorGridText {
    HasChanged = 'has changed',
    HasValue = 'has a value',
    NoValue = 'has no value',
    Equal = 'is set to',
}

export enum UploaderTriggerOperatorText {
    HasChanged = 'field has changed',
    HasValue = 'field has a file',
    NoValue = 'field has no file',
}

export enum UploaderTriggerOperatorGridText {
    HasChanged = 'has changed',
    HasValue = 'has a file',
    NoValue = 'has no file',
}

export enum NumberTriggerOperatorText {
    HasChanged = 'field has changed',
    HasValue = 'field has a value',
    NoValue = 'field has no value',
    GreaterThan = 'field is greater than',
    LessThan = 'field is less than',
    EqualTo = 'field is equal to',
    GreaterThanOrEqualTo = 'field is greater than or equal to',
    LessThanOrEqualTo = 'field is less than or equal to',
}

export enum NumberTriggerOperatorGridText {
    HasChanged = 'has changed',
    HasValue = 'has a value',
    NoValue = 'has no value',
    GreaterThan = 'is greater than',
    LessThan = 'is less than',
    EqualTo = 'field is equal to',
    GreaterThanOrEqualTo = 'field is greater than or equal to',
    LessThanOrEqualTo = 'field is less than or equal to',
}

export enum DefaultTriggerOperatorText {
    HasChanged = 'field has changed',
    HasValue = 'field has a value',
    NoValue = 'field has no value',
}

export enum DefaultTriggerOperatorGridText {
    HasChanged = 'has changed',
    HasValue = 'has a value',
    NoValue = 'has no value',
    ElseDoThis = 'ELSE DO THIS, ',
    IncompleteLogicSet = 'Incomplete Logic set'
}

export enum SiteStateTriggerOperatorText {
    Equal = 'is in',
    NotEqual = 'is not in',
}

export enum SiteStatusTriggerOperatorText {
    Equal = 'is',
    NotEqual = 'is not',
}
